import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { InvoiceService } from '../../invoice/invoice/invoice.service';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';
import { TicketService } from '../../invoice/tickets/ticket.service';

@Component({
    selector: 'app-salesreport',
    templateUrl: './salesreport.component.html',
    styleUrls: ['./salesreport.component.css'],
    standalone: false
})
export class SalesReportComponent implements OnInit {
  searchForm: UntypedFormGroup;
  invoices: any[] = [];
  errorMessage = '';
  searching = false;
  hasSearched = false;

  constructor(
    private fb: UntypedFormBuilder,
    private invoiceService: InvoiceService,
    private ticketService: TicketService
  ) { }

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchInput: [''],
      searchSerialNumber: [''],
      startDate: [null],
      endDate: [null],
      searchClient: [''],
      searchConcept: ['']
    });
  }

  search(): void {
    const filters: any = {};
    const form = this.searchForm.value;

    if (form.searchInput && form.searchInput.trim()) filters.number = form.searchInput.trim();
    if (form.searchSerialNumber && form.searchSerialNumber.trim()) filters.serialNumber = form.searchSerialNumber.trim();
    if (form.searchClient && form.searchClient.trim()) filters.client = form.searchClient.trim();
    if (form.startDate) filters.start = new Date(form.startDate).toISOString().split('T')[0];
    if (form.endDate) filters.end = new Date(form.endDate).toISOString().split('T')[0];
    if (form.searchConcept && form.searchConcept.trim()) filters.concept = form.searchConcept.trim();

    if (Object.keys(filters).length === 0) {
      this.errorMessage = 'Introduce al menos un filtro para buscar.';
      return;
    }

    this.invoices = [];
    this.errorMessage = '';
    this.searching = true;
    this.hasSearched = false;

    this.invoiceService.searchInvoices(filters)
      .then((response: any) => {
        this.invoices = [
          ...(response.invoicesList || []),
          ...(response.ticketList || [])
        ];
        if (this.invoices.length === 0) {
          this.errorMessage = 'No se encontraron documentos con esos filtros.';
        }
        this.searching = false;
        this.hasSearched = true;
      })
      .catch(() => {
        this.errorMessage = 'Ocurrió un error al realizar la búsqueda.';
        this.searching = false;
        this.hasSearched = true;
      });
  }

  downloadDocument(item: any) {
    console.log("Documento que llega", item);

    if (item.invoiceNumber || item.preInvoiceNumber) {
      const name = item.invoiceNumber || item.preInvoiceNumber || 'documento';
      this.invoiceService.pdf(item.uid, consts.EMPTY_GUID).then(response => {
        FileSaver.saveAs(response, name + '.pdf');
      });
      return;
    }

    if (item.ticketNumber) {
      const name = item.ticketNumber || 'ticket';
      this.ticketService.pdf(item.uid).then(response => {
        FileSaver.saveAs(response, name + '.pdf');
      });
      return;
    }

    this.errorMessage = 'No se puede descargar este documento (tipo desconocido).';
  }

  public trackByIndex(i: number) { return i; }

}
